
import { Options, Vue } from 'vue-class-component';
import braConfig from '../components/braConfig.vue';
import bottomUnderwearConfig from '../components/bottomUnderwearConfig.vue';
import lingerieConfig from '../components/lingerieConfig.vue';
import pajamasConfig from '../components/pajamasConfig.vue';

@Options({
    components: {
        braConfig,
        bottomUnderwearConfig,
        lingerieConfig,
        pajamasConfig
    }
})
export default class underwear extends Vue {

    activeSection: string = "BRA";

}
